import { render, staticRenderFns } from "./FormUserSteps.vue?vue&type=template&id=0f1a76d6&"
import script from "./FormUserSteps.vue?vue&type=script&lang=js&"
export * from "./FormUserSteps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports